export default class FeaturesAccordion {
    constructor(element) {
        this.selector = element;
        this.initActiveState();
        this.open();
    }

    open() {
        const headers = this.selector.querySelectorAll('[data-item-header]');
        headers.forEach((header) => {
            header.addEventListener('click', () => {
                const item = header.closest('[data-item]');
                if (!item) return;
                const content = item.querySelector('[data-item-content]');
                const image = this.selector.querySelector(`[data-item-image="${item.dataset.item}"]`);

                const activeItem = this.selector.querySelector('[data-item].active');
                const activeContent = activeItem ? activeItem.querySelector('[data-item-content]') : null;
                const activeImage = this.selector.querySelector('[data-item-image].opacity-100');
                const activeHeader = activeItem ? activeItem.querySelector('[data-item-header]') : null;

                // Already active: do nothing.
                if (item.classList.contains('active')) {
                    return;
                }

                // Activate new item
                item.classList.add('active');
                if (image) {
                    image.classList.add('opacity-100');
                    image.classList.remove('opacity-0');
                }
                if (content) {
                    content.style.maxHeight = `${content.scrollHeight}px`;
                }

                // Deactivate previous item
                if (activeItem && activeItem !== item) {
                    activeItem.classList.remove('active');
                    if (activeImage) {
                        activeImage.classList.remove('opacity-100');
                        activeImage.classList.add('opacity-0');
                    }
                    if (activeContent) {
                        activeContent.style.maxHeight = 0;
                    }
                }
            });
        });
    }

    initActiveState() {
        const initialActive = this.selector.querySelector('[data-item].active');
        if (!initialActive) return;

        // Set an explicit maxHeight on the initially-open content so the
        // CSS transition (max-height) can animate from a real value → 0
        // on the first click instead of snapping from "auto".
        const content = initialActive.querySelector('[data-item-content]');
        if (content) {
            content.style.maxHeight = `${content.scrollHeight}px`;
        }
    }
}